import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import ReferralHash from "../../../common/referral-hash";

import Field from "features/application/field/component";

import "features/application/sign-up/view.scss";

const SignUpView = ({
  currentStep,
  errorCodes,
  urlUserId,
  formReference,
  referrerReference,
  sendApiRequest,
}) => (
  <form
    className="application__container"
    noValidate
    ref={formReference}
    onSubmit={sendApiRequest}
  >
    <h1 className="application__headline sign-up__headline">
      Join the Collective
    </h1>
    <p className="authentication__description">
      <span className="authentication__description--light">
        Already have an&nbsp;account?{" "}
      </span>
      <Link
        className="authentication__link sign-up__link"
        to={
          "/application/sign-in" +
          (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
        }
      >
        Login here.
      </Link>
    </p>
    <div className="sign-up__container">
      <div className="authentication__container sign-up__origin">
        <Field
          label="E-mail address"
          name="email"
          type="email"
          autoComplete="off"
          maxLength={320}
          shouldValidate={true}
          rule="email"
          error="It doesn't look like a valid e-mail address."
        />
        <Field
          label="Create a password"
          name="password"
          type="password"
          autoComplete="off"
          maxLength={64}
          shouldValidate={true}
          rule="password"
          error="Password must be at least 8 characters long. The password must contain at least one lowercase character, one uppercase character and one digit."
        />
      </div>
      {urlUserId === "premium" && (
        <div className="authentication__container">
          <Field
            label="Referrer's e-mail address"
            name="referrer"
            type="email"
            autoComplete="off"
            maxLength={320}
            shouldValidate={
              referrerReference.current && referrerReference.current.value
                ? true
                : false
            }
            rule="email"
            error="It doesn't look like a valid e-mail address."
            reference={referrerReference}
          />
          <Field
            label="Code"
            placeholder="Required"
            name="code"
            type="text"
            autoComplete="off"
            maxLength={191}
            shouldValidate={true}
            rule="required"
            error="This field is required."
          />
        </div>
      )}
      {currentStep === "referral" && (
        <div className="authentication__container">
          <Field
            label="Referrer's e-mail address"
            name="referral"
            type="email"
            autoComplete="off"
            maxLength={320}
            shouldValidate={true}
            rule="email"
            error="It doesn't look like a valid e-mail address."
          />
        </div>
      )}
    </div>
    <p>
      By signing up you agree to&nbsp;
      <Link
        className="authentication__link"
        to="/privacy-policy"
        target="blank"
        onClick={() => window.dataLayer.push({ event: "privacyVisited" })}
      >
        Privacy Policy
      </Link>
      &nbsp;and&nbsp;
      <Link
        className="authentication__link"
        to="/terms-and-conditions"
        target="blank"
        onClick={() => window.dataLayer.push({ event: "termsVisited" })}
      >
        Terms and Conditions
      </Link>
    </p>
    {errorCodes.signUp && errorCodes.signUp === 422 ? (
      <p className="authentication__information">
        There is already an account with this email registered.
      </p>
    ) : errorCodes.signUp && errorCodes.signUp === 401 ? (
      <p className="authentication__information">
        Your credentials were incorrect.
      </p>
    ) : (
      errorCodes.signUp && (
        <p className="authentication__information">
          Your credentials were incorrect.
        </p>
      )
    )}
    <input className="application__button" type="submit" value="Submit" />
  </form>
);

SignUpView.propTypes = {
  currentStep: PropTypes.string,
  errorCodes: PropTypes.object,
  urlUserId: PropTypes.string,
  formReference: PropTypes.object,
  referrerReference: PropTypes.object,
  sendApiRequest: PropTypes.func,
};

export default SignUpView;
